import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '../ui/button';

export default function ScoreEntry({ pointsToWin = 11, busy, onSubmit, onCancel, nameA, nameB }) {
  const [a, setA] = useState(String(pointsToWin));
  const [b, setB] = useState('');
  const na = Number(a), nb = Number(b);
  const valid = a !== '' && b !== '' && na >= 0 && nb >= 0 && na !== nb;

  const winner = (side) => {
    if (side === 'a') { setA(String(pointsToWin)); if (b === '' || Number(b) >= pointsToWin) setB(''); }
    else { setB(String(pointsToWin)); if (a === '' || Number(a) >= pointsToWin) setA(''); }
  };

  return (
    <div className="mt-2 rounded-xl bg-muted/50 p-2.5 space-y-2" data-testid="score-entry">
      <div className="grid grid-cols-2 gap-2">
        <button type="button" onClick={() => winner('a')} data-testid="winner-a-btn"
          className={`h-8 rounded-full text-xs font-bold border truncate px-2 ${na > nb && b !== '' ? 'bg-emerald-500/20 border-emerald-500/50' : 'border-border'}`}>
          🏅 {nameA} won
        </button>
        <button type="button" onClick={() => winner('b')} data-testid="winner-b-btn"
          className={`h-8 rounded-full text-xs font-bold border truncate px-2 ${nb > na && a !== '' ? 'bg-emerald-500/20 border-emerald-500/50' : 'border-border'}`}>
          🏅 {nameB} won
        </button>
      </div>
      <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-2">
        <input type="number" inputMode="numeric" min="0" value={a} onChange={(e) => setA(e.target.value)} data-testid="score-a-input"
          className="h-12 rounded-xl border bg-background text-center font-display font-black text-2xl tabular-nums w-full" placeholder="A" />
        <span className="font-display font-black text-muted-foreground">–</span>
        <input type="number" inputMode="numeric" min="0" value={b} onChange={(e) => setB(e.target.value)} data-testid="score-b-input"
          className="h-12 rounded-xl border bg-background text-center font-display font-black text-2xl tabular-nums w-full" placeholder="B" />
      </div>
      <div className="flex gap-2">
        <Button variant="ghost" size="sm" className="rounded-full" onClick={onCancel} data-testid="score-cancel-btn">Cancel</Button>
        <Button size="sm" className="rounded-full flex-1 h-9" disabled={!valid || busy} onClick={() => onSubmit(na, nb)} data-testid="score-save-btn">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Save result'}
        </Button>
      </div>
    </div>
  );
}
